/* px-aplus.js — Amazon A+ Premium 模組的互動(分頁、產品輪播、hero 影片)。每個 px-aplus-* section 都載同一支,用守衛只跑一次。 */
(function () {
  if (window.__pxAplus) return;
  window.__pxAplus = true;

  function init(root) {
    root.querySelectorAll('[data-px-tabs]').forEach(function (el) {
      if (el.__pxInit) return; el.__pxInit = true;
      var tabs = el.querySelectorAll('[data-px-tab]');
      var panels = el.querySelectorAll('[data-px-panel]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.hidden = j !== i; });
        });
      });
    });

    root.querySelectorAll('[data-px-carousel]').forEach(function (el) {
      if (el.__pxInit) return; el.__pxInit = true;
      var track = el.querySelector('[data-px-track]');
      var slides = track.children;
      var dots = el.querySelectorAll('[data-px-dot]');
      var prev = el.querySelector('[data-px-prev]');
      var next = el.querySelector('[data-px-next]');
      function index() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
      function go(i) {
        var n = slides.length; if (!n) return;
        i = (i + n) % n;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      track.addEventListener('scroll', function () {
        var i = index();
        dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }, { passive: true });
    });

    root.querySelectorAll('[data-px-hotspots]').forEach(function (el) {
      if (el.__pxInit) return; el.__pxInit = true;
      var spots = el.querySelectorAll('.px-aplus__hot-spot');
      spots.forEach(function (spot) {
        var btn = spot.querySelector('[data-px-hot]');
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = spot.classList.contains('is-open');
          spots.forEach(function (s) { s.classList.remove('is-open'); s.querySelector('[data-px-hot]').setAttribute('aria-expanded', 'false'); });
          if (!open) { spot.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });
      document.addEventListener('click', function () { spots.forEach(function (s) { s.classList.remove('is-open'); }); });
    });

    root.querySelectorAll('[data-px-hero]').forEach(function (el) {
      if (el.__pxInit) return; el.__pxInit = true;
      var btn = el.querySelector('[data-px-play]');
      var video = el.querySelector('video');
      if (!btn || !video) return;
      btn.addEventListener('click', function () {
        el.classList.add('is-playing');
        video.setAttribute('controls', '');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
